import { createContext } from "react";

import { UserHelper } from "./UserHelper.tsx";

export const UserContext = createContext<UserHelper>({} as UserHelper);
